import { NotificationController } from 'src/core/classes/notification/Controller'

export const initCoreNotificationTemplates = () => {
  NotificationController.addTemplate(
    'DEFAULT_CHAT_MENTION_TEMPLATE',
    () => import('./DefaultChatMentionPushTemplate')
  )
}
